import { Modal } from '@mantine/core'
import SettingsContent from './_SettingsContent'
import { useI18n } from './_i18n'
import { TILE } from './stations/_tiles'
import './_overlay.css'

// Settings as a topnav overlay (opened from the gear), mirroring the search
// overlay. Same controls as the /settings page (shared SettingsContent). Styled
// in the app's navy list-card language: TILE.dark body, TILE.mid header band.
export default function SettingsOverlay({ opened, onClose }) {
  const { t } = useI18n()
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t('settings')}
      size="md"
      radius="md"
      yOffset="8vh"
      // `fade` (opacity only) rather than the default `pop` (which scales via
      // transform): the SegmentedControls inside measure their active-pill size on
      // mount, and a scale transform in progress makes them measure a shrunken,
      // off-center pill that never recomputes. Fade has no transform, so they
      // measure true size.
      transitionProps={{ transition: 'fade', duration: 150 }}
      overlayProps={{ backgroundOpacity: 0.55, blur: 3 }}
      styles={{
        content: { background: TILE.dark },
        header: { background: TILE.mid, color: '#fff' },
        title: { color: '#fff', fontWeight: 700, letterSpacing: 0.3 },
        close: { color: '#fff', '--ai-color': '#fff' },
        body: { background: TILE.dark, paddingTop: 'var(--mantine-spacing-lg)' },
      }}
    >
      <SettingsContent />
    </Modal>
  )
}
